<template>
  <div class="user-profile">
    <div class="head-box">
      <el-image :src="avatarSrc" class="avatar-wrapper" @click="handlePreview">
        <div slot="error" class="image-slot">
          <img :src="defaultSrc" />
        </div>
      </el-image>
    </div>
    <div class="name-box">
      <span class="name">{{ initWidthName }}</span>
      <span v-if="profile.sex == '男'" class="male">
        <i class="el-icon-male"></i>
      </span>
      <span v-else class="female">
        <i class="el-icon-female"></i>
      </span>
      <el-button @click="openSetRemark" type="primary" :class="setRemarkClass"
        >设置备注姓名</el-button
      >
    </div>
    <div class="number-box">{{ profile.handNum }}</div>
    <div class="fans-box">
      <ul class="info-container">
        <li @click="linkToFollow">
          <p class="info-num">{{ initWidthFollowing }}</p>
          <p class="info-text">关注</p>
        </li>
        <li @click="linkToFans">
          <p class="info-num">{{ initWidthFollower }}</p>
          <p class="info-text">粉丝</p>
        </li>
        <li @click="linkToStar">
          <p class="info-num">{{ profile.star }}</p>
          <p class="info-text">星级</p>
        </li>
      </ul>
    </div>
    <div class="link-box">
      <div v-if="profileMenu.linkBtn">
        <p class="user-link-wrapper">
          <a href="javascript:;" @click="userCenterLink">{{
            initWidthLinkName
          }}</a>
        </p>
      </div>
      <div v-else ref="profileMenu">
        <p class="user-link-wrapper" v-if="profileMenu.addFriendBtn">
          <a href="javascript:;" @click="applyForFirend">加为好友</a>
        </p>
        <p class="user-link-wrapper" v-if="profileMenu.applyTreeBtn">
          <a href="javascript:;" @click="applyForTree">申请传连</a>
        </p>
        <p class="user-link-wrapper" v-if="profileMenu.modifyTreeBtn">
          <a href="javascript:;" @click="modifyWithTree">修改传连</a>
        </p>
        <p class="user-link-wrapper" v-if="profileMenu.copyTreeBtn">
          <a href="javascript:;" @click="applyCopyTree">复制家谱</a>
        </p>
      </div>
    </div>
    <div class="set-remark-wrap">
      <el-dialog
        title="设置备注"
        :visible.sync="remarkDialog"
        custom-class="handlian-report-container"
        :showClose="false"
        width="480px"
      >
        <el-form
          :model="remarkForm"
          ref="remarkForm"
          :rules="remarkRules"
          label-width="80px"
        >
          <el-form-item label="备注姓名" prop="name">
            <el-input ref="remarkInput" v-model="remarkForm.name"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="handlian-btn" @click="resetForm('remarkForm')"
            >取 消</el-button
          >
          <el-button
            class="handlian-btn"
            type="primary"
            @click="submitForm('remarkForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div class="handlian-apply-wrapper">
      <el-dialog
        title="选择传连关系"
        :visible.sync="applyVisible"
        width="550px"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        :before-close="clearApplyForm"
        custom-class="handlian-share-feed"
      >
        <div>
          <div class="apply-card-profile flex">
            <div class="apply-card-avatar">
              <el-image :src="avatarSrc" class="card-avatar-wrapper">
                <div slot="error" class="image-slot">
                  <img :src="defaultSrc" />
                </div>
              </el-image>
            </div>
            <div class="user-info-container">
              <p class="apply-profile-name">
                <span class="name">{{ initWidthName }}</span>
                <span v-if="profile.sex == '男'" class="male">
                  <i class="el-icon-male"></i>
                </span>
                <span v-else class="female">
                  <i class="el-icon-female"></i>
                </span>
              </p>
              <p class="star-count">星级：{{ profile.star }}</p>
              <p>{{ profile.handNum }}</p>
            </div>
          </div>
          <div class="card-name-wrap">
            <span class="apply-card-name">{{ profile.realName }}</span
            >是我的
          </div>
          <div>
            <el-form
              :model="applyRelationForm"
              :rules="relationRules"
              ref="applyRelationForm"
              :inline="true"
            >
              <el-form-item prop="relation" label="选择关系">
                <el-select
                  v-model="applyRelationForm.relation"
                  placeholder="— 亲人关系 —"
                >
                  <el-option
                    v-for="(item, index) in relationList"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="handlian-btn add-member-button"
                  type="primary"
                  @click="submitAddForm('applyRelationForm')"
                  >确定</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { apiMap } from "../utils/apiMap";
import { birthToDate } from "../utils/feed";
import qs from "qs";
export default {
  name: "user-profile",
  props: {
    profile: Object,
    profileMenu: Object,
  },
  data() {
    var validateRelation = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请选择关系"));
      } else {
        callback();
      }
    };
    return {
      isFriend: false,
      applyTreeBtn: false,
      modifyTreeBtn: false,
      copyTreeBtn: false,
      remarkDialog: false,
      setRemarkBtn: false,
      applyVisible: false,
      remarkForm: {
        name: "",
      },
      remarkRules: {
        name: [
          { required: true, message: "请输入备注姓名", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      applyRelationForm: {
        relation: "",
      },
      relationRules: {
        relation: [{ validator: validateRelation, trigger: "change" }],
      },
      relationList: [],
    };
  },
  computed: {
    ...mapGetters(["userProfile", "contactBook"]),
    avatarSrc: function () {
      let src = this.profile.thumbHeadImg || this.profile.headImgUrl;
      if (/^(https:|http:|\/\/)/.test(src)) {
        return src;
      } else {
        return this.defaultSrc;
      }
    },
    defaultSrc: function () {
      return "http://148.70.221.198/pc/image/cl_user_avatar.png";
    },
    initWidthFollowing() {
      if (this.profile && this.profile.subscribeNum) {
        return this.profile.subscribeNum;
      } else {
        return "0";
      }
    },
    initWidthFollower() {
      if (this.profile && this.profile.followerNum) {
        return this.profile.followerNum;
      } else {
        return "0";
      }
    },
    initWidthName() {
      if (this.profile.markInfo && this.profile.markInfo.mark != "") {
        return this.profile.markInfo.mark;
      } else {
        return this.profile.name;
      }
    },
    initWidthLinkName() {
      if (this.profile.userId == this.userProfile.userId) {
        return "我的主页";
      } else {
        switch (this.profile.sex) {
          case "男":
            return "他的主页";
          case "女":
            return "她的主页";
          default:
            return "TA的主页";
        }
      }
    },
    setRemarkClass() {
      // console.log(this.profileMenu)
      if (this.profile.userId == this.userProfile.userId) {
        return "forbit-remark";
      } else {
        if (this.profileMenu.setRemarkBtn == false) {
          return "forbit-remark";
        } else {
          return "set-remark-btn";
        }
      }
    },
  },
  methods: {
    handlePreview() {
      this.$bus.$emit("avatar-preview", {
        url: this.profile.thumbHeadImg || this.avatarSrc,
      });
    },
    userCenterLink() {
      this.$router.push({
        path: "/feed",
        query: {
          id: this.profile.userId,
        },
      });
    },
    applyForFirend() {
      this.$alert("请在手机端添加好友", {
        confirmButtonText: "确定",
        showClose: false,
      });
    },
    modifyWithTree() {
      var tipText =
        "该亲人已经在你的家谱中，如果错了，请先与相关人断连后，重新传连。";
      this.$alert(tipText, {
        confirmButtonText: "确定",
        showClose: false,
      });
    },
    applyForTree() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["getProfile"]["method"],
          url: apiMap["getProfile"]["url"],
          data: `token=${loginUser.token}&userId=${loginUser.userId}`,
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            let myProfile = response.data.result.data;
            let friendProfile = _this.profile;
            if (friendProfile.hasOwnProperty("isValiated")) {
              if (myProfile["isValiated"] == 0) {
                _this.$alert("您未在手机端实名认证，暂时不能传连", {
                  confirmButtonText: "确定",
                  showClose: false,
                  callback: (action) => {
                    _this.applyVisible = false;
                  },
                });
                return false;
              }
              if (friendProfile["isValiated"] == 0) {
                _this.$alert("对方未在手机端实名认证，暂时不能传连", {
                  confirmButtonText: "确定",
                  showClose: false,
                  callback: (action) => {
                    _this.applyVisible = false;
                  },
                });
                return false;
              }

              var myBirth = birthToDate(myProfile["birthday"]);
              var friendBirth = birthToDate(friendProfile["birthday"]);
              var ageDiffer = friendBirth - myBirth;
              var relations = [];
              if (ageDiffer > 0 || ageDiffer == 0) {
                relations = _this.getRelationShip(
                  friendProfile["sex"],
                  myProfile["sex"],
                  "小"
                );
              } else if (ageDiffer < 0) {
                relations = _this.getRelationShip(
                  friendProfile["sex"],
                  myProfile["sex"],
                  "大"
                );
              }
              if (relations.length != 0) {
                for (let index = 0; index < relations.length; index++) {
                  const element = relations[index];
                  var callText = element == "儿女" ? "女儿" : element;
                  let item = {
                    text: callText,
                    value: element,
                  };
                  _this.relationList.push(item);
                }
              }
              if (_this.relationList.length != 0) {
                _this.applyVisible = true;
              }
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getRelationShip(friendGender, myGender, age) {
      const map = new Map([
        [
          { friendGender: "男", myGender: "女", age: "小" },
          ["弟弟", "丈夫", "儿子", "孙子", "外孙"],
        ],
        [
          { friendGender: "男", myGender: "女", age: "大" },
          ["祖父", "外祖父", "父亲", "哥哥", "丈夫"],
        ],
        [
          { friendGender: "男", myGender: "男", age: "小" },
          ["弟弟", "儿子", "孙子", "外孙"],
        ],
        [
          { friendGender: "男", myGender: "男", age: "大" },
          ["祖父", "外祖父", "父亲", "哥哥"],
        ],

        [
          { friendGender: "女", myGender: "女", age: "小" },
          ["妹妹", "儿女", "孙女", "外孙女"],
        ],
        [
          { friendGender: "女", myGender: "女", age: "大" },
          ["祖母", "外祖母", "母亲", "姐姐"],
        ],
        [
          { friendGender: "女", myGender: "男", age: "小" },
          ["妻子", "妹妹", "儿女", "孙女", "外孙女"],
        ],
        [
          { friendGender: "女", myGender: "男", age: "大" },
          ["祖母", "外祖母", "母亲", "姐姐", "妻子"],
        ],
      ]);
      const item = [...map].filter(
        ([key, value]) =>
          key.friendGender === friendGender &&
          key.myGender === myGender &&
          key.age === age
      );
      const [key, value] = item[0];
      return value;
    },
    applyCopyTree() {
      let _this = this;
      _this.checkFriendTree(function (res) {
        switch (res.code) {
          case 0:
            _this.$alert("对方无祖先可复制，请尝试与他（她）传连吧！", {
              confirmButtonText: "确定",
              showClose: false,
            });
            break;
          case 1:
            _this.inBigTree(function (respond) {
              if (respond == 0) {
                _this.getMyTree(function (response) {
                  switch (response.code) {
                    case 0:
                      _this.getMyProfile(function (res) {
                        if (res["isValiated"] == 1) {
                          var tips = `如果你们有共同祖先，且对方已经添加完成,\n请使用该功能`;
                          _this
                            .$confirm(tips, {
                              confirmButtonText: "确定",
                              closeOnClickModal: false,
                              showClose: false,
                              customClass: "cl-edit-profile",
                            })
                            .then(() => {
                              _this.submitCopyApply();
                            })
                            .catch(() => {});
                        } else {
                          _this.$alert(
                            "你未在传联APP进行实名认证，暂不能复制家谱",
                            {
                              confirmButtonText: "确定",
                              showClose: false,
                            }
                          );
                        }
                      });
                      break;
                    case 1:
                      var tips = `如果你们有共同祖先，且对方已经添加完成,\n请使用该功能`;
                      _this
                        .$confirm(tips, {
                          confirmButtonText: "确定",
                          closeOnClickModal: false,
                          showClose: false,
                          customClass: "cl-edit-profile",
                        })
                        .then(() => {
                          _this.submitCopyApply();
                        })
                        .catch(() => {});
                      break;
                    case 2:
                      _this.$alert(
                        "为了使家谱信息准确无误，至少完善自己的父亲节点，才可以复制家谱。",
                        {
                          confirmButtonText: "确定",
                          showClose: false,
                        }
                      );
                      break;
                    case 3:
                      _this.$alert(
                        "请完善你家谱中最顶上男性的资料，再申请复制",
                        {
                          confirmButtonText: "确定",
                          showClose: false,
                        }
                      );
                      break;
                    case 4:
                      var errInfo = `系统显示，${response.userName} 健在，为减少错误概率，他才有权复制家谱！`;
                      _this.$alert(errInfo, {
                        confirmButtonText: "确定",
                        showClose: false,
                      });
                      break;
                  }
                });
              } else {
                _this.$alert("你们已经在一个族谱中无需复制！", {
                  confirmButtonText: "确定",
                  showClose: false,
                });
              }
            });
            break;
          case 2:
            _this.$alert("对方无祖先可复制，请尝试与他（她）传连吧！", {
              confirmButtonText: "确定",
              showClose: false,
            });
            break;
        }
      });
    },
    linkToFollow() {
      let routeName = this.$route.name;
      if (routeName != "UserFollow") {
        this.$router.push({
          path: "/follow",
          query: {
            id: this.profile.userId,
          },
        });
      }
    },
    linkToFans() {
      let routeName = this.$route.name;
      if (routeName != "UserFans") {
        this.$router.push({
          path: "/fans",
          query: {
            id: this.profile.userId,
          },
        });
      }
    },
    linkToStar() {
      if (this.profile.userId == this.userProfile.userId) {
        let routeName = this.$route.name;
        if (routeName != "UserAccount") {
          this.$router.push({ path: "/account" });
        }
      }
    },
    openSetRemark() {
      if (this.profile.userId !== this.userProfile.userId) {
        this.remarkDialog = true;
        if (this.profile.markInfo && this.profile.markInfo.mark != "") {
          this.remarkForm.name = this.profile.markInfo.mark;
        }
        setTimeout(() => {
          this.$refs.remarkInput.focus();
        }, 500);
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.setRemarkToHandLian();
          this.resetForm("remarkForm");
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.remarkDialog = false;
    },
    setRemarkToHandLian() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["setRemark"]["method"],
          url: apiMap["setRemark"]["url"],
          data: `token=${loginUser.token}&mark=${_this.remarkForm.name}&whoId=${_this.profile.userId}`,
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            _this.$bus.$emit("update-friend-profile");
            _this.$message({
              message: "设置成功！",
              type: "success",
            });
          } else {
            _this.$alert(response.data.result.data, {
              confirmButtonText: "确定",
              showClose: false,
            });
          }
        });
    },
    submitAddForm(formName) {
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          let checkedRelation = _this.$refs[formName].model.relation;
          let checkRelation = ["哥哥", "弟弟", "姐姐", "妹妹"];
          let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
          var params = {
            token: loginUser.token,
            relationName: checkedRelation,
            relationUserId: _this.profile.userId,
          };
          if (checkRelation.includes(checkedRelation)) {
            _this.checkFriendTree(function (res) {
              if (res.code == 1) {
                //对方有父亲
                _this.getMyTree(function (respond) {
                  let resArr = [1, 3, 4];
                  if (resArr.includes(respond.code)) {
                    //我自己有父亲
                    var tipName = _this.profile.realName || _this.profile.name;
                    let tipText = `传连成功后，你家谱中的父（母）将发生变更，与${tipName}一致。确定要发送申请吗？`;
                    _this
                      .$confirm(tipText, {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        customClass: "cl-copy-confirm",
                        showClose: false,
                      })
                      .then(() => {
                        _this.submitHandApply(params);
                      })
                      .catch(() => {});
                  } else {
                    _this.submitHandApply(params);
                  }
                });
              } else {
                _this.submitHandApply(params);
              }
            });
          } else {
            _this.submitHandApply(params);
          }
        } else {
          return false;
        }
      });
    },
    submitHandApply(params) {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["applyHandlian"]["method"],
          url: apiMap["applyHandlian"]["url"],
          data: qs.stringify(params, { encode: false }),
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            _this.$alert(response.data.result.data, {
              confirmButtonText: "确定",
              showClose: false,
              callback: (action) => {
                _this.clearApplyForm();
              },
            });
          } else {
            _this.$alert(response.data.result.data, {
              confirmButtonText: "确定",
              showClose: false,
              callback: (action) => {
                _this.clearApplyForm();
              },
            });
          }
        });
    },
    clearApplyForm() {
      this.applyVisible = false;
      this.applyRelationForm.relation = "";
      this.relationList = [];
    },
    checkFriendTree(okCBK) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["fatherTree"]["method"],
          url: apiMap["fatherTree"]["url"],
          params: {
            token: loginUser.token,
            userId: _this.profile.userId,
          },
        })
        .then(function (response) {
          var res = {};
          res.code = response.data.result.statusCode;
          if (response.data.result.statusCode == 1) {
            if (response.data.result.data.userId == _this.profile.userId) {
              res.code = 2;
            }
          }
          okCBK(res);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    inBigTree(okCBK) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var params = {
        token: loginUser.token,
        userId: _this.profile.userId,
        family: 1,
      };
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["getProfile"]["method"],
          url: apiMap["getProfile"]["url"],
          data: qs.stringify(params, { encode: false }),
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            okCBK(response.data.result.data.inFatherFamilyTree);
          } else {
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getMyTree(okCBK) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["fatherTree"]["method"],
          url: apiMap["fatherTree"]["url"],
          params: {
            token: loginUser.token,
          },
        })
        .then(function (response) {
          var res = {};
          res.code = response.data.result.statusCode;
          if (response.data.result.statusCode == 1) {
            let ancestorID = response.data.result.data.userId;
            let curUserID = loginUser.userId.toString();
            res.userName = response.data.result.data.userName;
            // if (ancestorID != curUserID) {
            //   //如果自己有父亲
            //     if (response.data.result.data.status==0) {//活人不能复制
            //         res.code = 4;
            //     }else if (response.data.result.data.status==1) {//临时节点不能复制
            //         res.code = 3;
            //     }
            // } else {
            //   res.code = 2;
            // }
            if (ancestorID != curUserID) {
              if (response.data.result.data.status == 1) {
                //临时节点不能复制
                res.code = 3;
              }
            }
          }
          okCBK(res);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    submitCopyApply() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var params = {
        token: loginUser.token,
        toUserId: _this.profile.userId,
      };
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["applyCopy"]["method"],
          url: apiMap["applyCopy"]["url"],
          data: qs.stringify(params, { encode: false }),
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            var tipText = "申请已提交，等待对方同意。";
            _this.$alert(tipText, {
              confirmButtonText: "确定",
              showClose: false,
            });
          } else {
            _this.$alert(response.data.result.data, {
              confirmButtonText: "确定",
              showClose: false,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getMyProfile(okCBK) {
      this.$axios({
        baseURL: apiMap["commonUrl"],
        method: apiMap["getProfile"]["method"],
        url: apiMap["getProfile"]["url"],
        data: `token=${loginUser.token}`,
      })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            okCBK(response.data.result.data);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style>
.user-profile {
  padding: 15px 10px;
}

.head-box {
  display: flex;
  justify-content: center;
  padding: 10px 0 10px;
}

.head-box .avatar-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 1px solid #f4f4f4;
}

.avatar-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.name-box {
  position: relative;
  height: 40px;
  line-height: 40px;
  text-align: center;
}

.name-box .name {
  font-size: 16px;
  font-weight: bold;
}

.name-box span:nth-child(2) {
  position: absolute;
  top: 0;
  margin-left: 5px;
}

.name-box .male {
  color: #0071ff;
}

.name-box .female {
  color: #ff4081;
}

.number-box {
  line-height: 18px;
  text-align: center;
}

.fans-box {
  margin: 15px 0;
  text-align: center;
}

.info-container {
  display: flex;
  justify-content: space-evenly;
}

.info-container li {
  width: 33%;
}

.info-container li:nth-child(2) {
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
}

.info-num {
  line-height: 20px;
  font-weight: bold;
}

.info-text {
  color: #808080;
}

.info-container li:hover .info-num {
  color: #eb7350;
}

.link-box {
  text-align: center;
  font-size: 16px;
}

.user-link-wrapper {
  width: 80%;
  margin: 0 auto;
  line-height: 30px;
}

.user-link-wrapper a {
  display: block;
  color: #1a70db;
}

.user-link-wrapper:hover {
  background-color: #1a70db;
}

.user-link-wrapper:hover a {
  color: #fff;
}

.forbit-remark {
  display: none;
}

.set-remark-btn {
  display: none;
  position: absolute;
  left: 109px;
  top: 3px;
  height: 30px;
  line-height: 30px;
  padding: 0 8px;
}

.name-box:hover .set-remark-btn {
  display: inline-block;
}

.apply-card-profile {
  margin: 13px 0;
}

.apply-card-avatar {
  width: 60px;
  height: 60px;
}

.card-name-wrap {
  margin-bottom: 15px;
  font-size: 16px;
}

.apply-card-name {
  margin-right: 5px;
  color: #0074d9;
}

.user-info-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 10px;
  line-height: 20px;
  font-size: 16px;
  color: #000;
}

.card-avatar-wrapper img {
  border-radius: 5px;
}

.star-count {
  padding-left: 22px;
  background-repeat: no-repeat;
  background-position: 1px 2px;
  background-image: url("../assets/icon/user/cl_level_star.png");
}

.apply-profile-name .male {
  margin-left: 5px;
  color: #0071ff;
}

.apply-profile-name .female {
  margin-left: 5px;
  color: #ff4081;
}
</style>